import Rater from "../courses/Rater";
export default Rater; 


// WEBPACK FOOTER //
// ./app/javascript/components/preloaded/Rater.tsx